/**
 * 언어 설정 쿠키의 도메인.
 *
 * localStorage 는 origin 단위라 shorty.kr 과 app.shorty.kr 이 설정을 공유하지
 * 못했다. 비로그인 방문자는 도메인을 옮길 때마다 언어를 다시 골라야 했다.
 * 상위 도메인에 쿠키를 심어 서브도메인끼리 공유한다.
 */

const SHARED_ROOT = 'shorty.kr'

/** 공유 가능한 호스트면 쿠키 도메인을, 아니면 undefined(지정 안 함) */
export function languageCookieDomain(
  hostname?: string | null
): string | undefined {
  if (!hostname) {
    return undefined
  }

  // 정확히 shorty.kr 이거나 그 하위 도메인일 때만 공유한다.
  // shorty.kr.evil.com 같은 호스트가 걸리지 않도록 끝자리를 확인한다.
  if (hostname === SHARED_ROOT || hostname.endsWith(`.${SHARED_ROOT}`)) {
    return `.${SHARED_ROOT}`
  }

  return undefined
}

export default languageCookieDomain
